<template>
  <v-card
    :class="[dueAlert.textClass]"
    :style="{ backgroundColor: dueAlert.backgroundColor, minHeight: '214px', maxHeight: '228px', overflow: 'hidden' }"
  >
    <v-col
      md="8"
      style="padding: 0; margin: 0; display: flex; flex-direction: column; justify-content: center;"
    >
      <v-card-title class="banner-title">
        {{ $t(`modules.portalalumno.dashboard.banners.due.hello${dueAlert.case}`, { studentName: $options.filters.$capitalizeAll(studentUserData.name) }) }},
      </v-card-title>
      <v-card-subtitle class="banner-subtitle">
          {{ $t(`modules.portalalumno.dashboard.banners.due.subtitle${dueAlert.case}`, { installments: studentData?.studentDue?.countPaymentsDebt }) }}
      </v-card-subtitle>
      <v-card-text class="banner-text">
        {{ $t(`modules.portalalumno.dashboard.banners.due.reminderAlert${dueAlert.case}`) }}
      </v-card-text>
      <v-card-text v-if="dueAlert.case > 2" class="banner-text">
        {{ $t(`modules.portalalumno.dashboard.banners.due.alert`) }}
      </v-card-text>
      <div v-if="dueAlert.case > 1" style="width: 100%;">
        <Button
          class="btn-due"
          :text="$t('modules.portalalumno.dashboard.banners.due.showDetail')"
          @clicked="redirect"
          :white="true"
          :textColor="'primary'"
          :size="'md'"
          :block="true"
        />
      </div>
    </v-col>
    <v-col
      md="4"
      class="img-container"
    >
      <v-img
        height="180"
        width="auto"
        :src="require(`@/assets/dashboard-assets/dashboard-due-alert${dueAlert.case}.png`)"
        contain
      />
    </v-col>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '/src/core/components/Button/Button.vue'

export default {
  name: 'DueBanner',
  components: { Button },
  computed: {
    dueAlert() {
      const installments = this.studentData?.studentDue?.countPaymentsDebt
      if (installments > 2) {
        return {
          case: 3,
          textClass: 'white--text',
          backgroundColor: '#E74746'
        }
      }
      if (installments === 2) {
        return {
          case: 2,
          textClass: 'white--text',
          backgroundColor: '#F7AA3E'
        }
      }
      if (installments < 2 || installments == null) {
        return {
          case: 1,
          textClass: 'black--text',
          backgroundColor: '#B8DCFF'
        }
      }
      if (this.$isTeclab) {
        return this.studentData.studentDue.firstAlertDue ? true : false
      }
      return {}
    },
    ...mapGetters({
      studentUserData: 'commons/getStudentUserData',
      studentData: 'commons/getStudentData'
    })
  },
  methods: {
    redirect() {
      this.$trackEvent('Home', 'Clk_BnrDeuda_Home', 'Deuda')
      this.$router.push('/payments')
    }
  }
}
</script>

<style lang="sass" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap')

.v-card
  border-radius: 10px
  padding: 12px 0 12px 18px
  display: flex
  min-height: 214px
  max-height: 228px
  overflow: hidden

::v-deep .v-card__title,
::v-deep .v-card__subtitle,
::v-deep .v-card__text
  margin: 0 0 5px 0
  padding: 0

.banner-title
  font-family: 'Poppins', sans-serif
  font-size: 23px
  font-weight: 800
  line-height: 28px
  white-space: pre-line

.banner-subtitle
  font-family: 'Poppins', sans-serif
  font-size: 20px
  font-weight: 700
  line-height: 24px

.banner-text
  font-family: 'Poppins', sans-serif
  font-size: 12px
  font-weight: 500
  line-height: 16px

.btn-due
  width: 70%
  height: 35px
  font-family: 'Poppins', sans-serif
  font-size: 12px
  font-weight: 500
  text-transform: none
  margin-top: 6px

.img-container
  display: flex
  align-items: center
  justify-content: flex-end
  margin: 0
  height: 100%
  min-width: 80px
  padding-top: 12px
  padding-bottom: 12px

.v-img
  max-width: 110%
</style>
